import React, { Component } from "react";
import { connect } from "react-redux";
import { updateChantier, deleteChantier } from "../actions/chantier";
import ChantiersDataService from "../services/chantier.service";

class Chantier extends Component {
  constructor(props) {
    super(props);
    this.onChangeNom = this.onChangeNom.bind(this);
    this.onChangeNumero=this.onChangeNumero.bind(this);

    this.getChantier = this.getChantier.bind(this);
    this.removeChantier = this.removeChantier.bind(this);
    this.updateChantier=this.updateChantier.bind(this);
    this.updatePublished=this.updatePublished.bind(this);

    this.state = {
      currentChantier: {
        id: null,
        Nom: "",
        Numero_chantier:"",

        published:false
      },

    };
  }

  componentDidMount() {
    this.getChantier(this.props.match.params.id);
  }

  onChangeNom(e) {
    const Nom = e.target.value;

    this.setState(function (prevState) {
      return {
        currentChantier: {
          ...prevState.currentChantier,
          Nom: Nom,
        },
      };
    });
  }

  onChangeNumero(e) {
    const Numero_chantier = e.target.value;

    this.setState(function (prevState) {
      return {
        currentChantier: {
          ...prevState.currentChantier,
          Numero_chantier: Numero_chantier,
        },
      };
    });
  }




  updatePublished(status) {
    var data = {
      id: this.state.currentChantier.id,
      Nom: this.state.currentChantier.Nom,
      Numero_chantier: this.state.currentChantier.Numero_chantier,

    };

    ChantiersDataService.update(
        this.state.currentChantier.id,
        data
    )
        .then(response => {
          this.setState(prevState => ({
            currentChantier: {
              ...prevState.currentChantier,
              published: true
            }
          }));
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
  }

  updateChantier() {
    ChantiersDataService.update(
        this.state.currentChantier.id,
        this.state.currentChantier
    )
        .then(response => {
          console.log(response.data);
          this.setState({
            message: "La mise à jour a été effectué",
          });
        }).then(response => {
      this.setState(prevState => ({
        currentChantier: {
          ...prevState.currentChantier,
          published: true
        }
      }));
      console.log(response.data);
    })
        .catch(e => {
          console.log(e);
        });
  }

  getChantier(id) {
    ChantiersDataService.get(id)
      .then((response) => {
        this.setState({
          currentChantier: response.data,
        });
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }



  removeChantier() {
    this.props
      .deleteChantier(this.state.currentChantier.id)
      .then(() => {
        this.props.history.push("/chantiers");
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    const { currentChantier,message } = this.state;

    return (
      <div>
        {currentChantier ? (
            <div>
              {!currentChantier.published && (
            <div>
          <div className="edit-form">
            <div>
            <h4>Mise à jour de : {currentChantier.Nom}, {currentChantier.Prenom}</h4>
            <form>
              <div className="form-group">
                <label htmlFor="Nom">Nom</label>
                <input
                    type="text"
                    className="form-control"
                    id="Nom"
                    value={currentChantier.Nom}
                    onChange={this.onChangeNom}
                />

                <label htmlFor="Numero">Numero de chantier</label>
                <input
                    type="text"
                    className="form-control"
                    id="Numero"
                    value={currentChantier.Numero_chantier}
                    onChange={this.onChangeNumero}
                />

              </div>
              <div>

                <div className="alert alert-light" role="alert">
                  {message}
                </div>


              </div>

              <div className="form-group">
                <label>
                  <strong>Status:</strong>
                </label>
                {currentChantier.published ? "Published" : "En cours de modification"}
              </div>
            </form>

          </div>

            <button
              className="badge badge-danger mr-2"
              onClick={this.removeChantier}
            >
              Supprimer
            </button>
            <a
                className="btn badge-success"
                onClick={this.updateChantier}
            >
              Mettre à jour
            </a>
          </div>

            </div>   )}
            {currentChantier.published===true && (
                <div>
                  <a
                      href="https://pointage.ansart-tp.com/chantiers/"
                  >
                    Revenir à la liste des chantiers
                  </a>

                </div>)}

          </div>

        ) : (
          <div>
            <br />
            <p>Erreur ce chantier n'éxiste pas ou n'est pas dans la base de données</p>
            <a
                href="https://pointage.ansart-tp.com/chantiers/"
            >
              Revenir à la liste des chantiers
            </a>
          </div>
        )
        }
      </div>

    );
  }
}

export default connect(null, { updateChantier, deleteChantier })(Chantier);
